// extracted by mini-css-extract-plugin
export default {"container":"YAxis_container__2VhSg","labels":"YAxis_labels__iXgI0","unitsContainer":"YAxis_unitsContainer__A0XQK","units":"YAxis_units__vLy9u"};